import { render, staticRenderFns } from "./IconAddSquare.vue?vue&type=template&id=2def471a&"
import script from "./IconAddSquare.vue?vue&type=script&lang=js&"
export * from "./IconAddSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports